import React, { useContext } from "react";
import { ConfirmDialog } from "iuvity-ui-components";
import { AppContext } from "../../context/index";

export interface DialogProps {
  title?: string;
  visible: boolean;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  handleModalState? : React.Dispatch<React.SetStateAction<DialogProps>> 
  content?: string;
  acceptLabel?: string;
  rejectLabel?: string;
  onConfirm?: any;
  closable?: boolean;
  onReject?: any;
}

export const CustomDialog: React.FC<DialogProps> = ({
  title,
  visible,
  setVisible,
  handleModalState,
  content,
  acceptLabel,
  rejectLabel,
  onConfirm = () => {},
  closable = true,
  onReject = false,
}) => {
  const { t } = useContext(AppContext);

  const onCloseModal = () => {
    if (setVisible) {
      setVisible(false);
    } else if (handleModalState) {
      handleModalState((prev: object) => ({
        ...prev,
        visible: false,
        onReject: false,
      }));
    }
  };

  return (
    <ConfirmDialog
      id='pr_id_1'
      className="confirmdialog-cancel"
      visible={visible}
      header={title}
      onHide={onCloseModal}
      message={content}
      accept={onConfirm}
      reject={onReject || onCloseModal}
      acceptLabel={acceptLabel || t("Options.acceptOptionLabel")}
      rejectLabel={rejectLabel || t("Options.rejectOptionLabel")}
      closable={closable}
      rejectClassName={onReject==='close' ? 'inactivity-reject-button' : ''}
    />
  );
};
